__turbopack_context__.v({
  "brandingStatement": "BrandingStatement-module-scss-module__o4HIZW__brandingStatement",
  "brandingStatement__clients": "BrandingStatement-module-scss-module__o4HIZW__brandingStatement__clients",
  "brandingStatement__content": "BrandingStatement-module-scss-module__o4HIZW__brandingStatement__content",
  "brandingStatement__icon": "BrandingStatement-module-scss-module__o4HIZW__brandingStatement__icon",
  "brandingStatement__imageWrapper": "BrandingStatement-module-scss-module__o4HIZW__brandingStatement__imageWrapper",
  "brandingStatement__imageWrapper_animated": "BrandingStatement-module-scss-module__o4HIZW__brandingStatement__imageWrapper_animated",
  "brandingStatement__statement": "BrandingStatement-module-scss-module__o4HIZW__brandingStatement__statement",
  "floating": "BrandingStatement-module-scss-module__o4HIZW__floating",
  "rotate": "BrandingStatement-module-scss-module__o4HIZW__rotate",
});
